<template>
  <div class="wspo-tabs">
    <div
      class="wspo-tab wspo-button-second"
      v-for="type in types"
      :key="type.id"
      @click="setType(type.id)"
      :class="{ 'wspo-active': isSelected(type.id) }"
    >
      {{ type.name }}
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Typelist',
  computed: {
    ...mapState(['type', 'types'])
  },
  methods: {
    ...mapMutations(['setType']),
    isSelected(id) {
      return this.type === id;
    }
  }
};
</script>

<style scoped>
/* .wspo-types {
  display: flex;
  flex-
}
.wspo-types-item {
  padding: 8px 18px;
  cursor: pointer;
}
.wspo-selected {
  background-color: var(--color-main);
  color: var(--color-paper);
} */

/* tabs */
.wspo-tabs {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.wspo-tab {
  border-radius: 0;
  flex: 1 100px;
}
.wspo-tab.wspo-active {
  background-color: var(--color-paper);
  border-top: 8px solid var(--color-alt-5);
  margin-top: 4px;
  border-bottom: 0;
  padding-top: 0;
}
</style>
